import type { DropdownProps } from '../Dropdown';

export const assertSingleSelect = <TMultiselect extends boolean>({
  multiselect,
  value,
  displaySelectedOptions,
  maxSelectedOptions,
}: Pick<
  DropdownProps<TMultiselect>,
  'multiselect' | 'value' | 'displaySelectedOptions' | 'maxSelectedOptions'
>) => {
  if (multiselect) {
    return;
  }
  if (displaySelectedOptions) {
    console.warn(
      'displaySelectedOptions is only available for multiselect dropdown',
    );
  }
  if (Array.isArray(value)) {
    throw new Error("value can't be an array for single select dropdown");
  }
  if (maxSelectedOptions !== undefined) {
    throw new Error(
      'maxSelectedOptions is not available for single select dropdown',
    );
  }
};
